import * as React from "react";
import PropTypes from "prop-types";
import { createTheme, styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import SettingsIcon from "@mui/icons-material/Settings";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import VideoLabelIcon from "@mui/icons-material/VideoLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import ArticleIcon from "@mui/icons-material/Article";
import Person4Icon from "@mui/icons-material/Person4";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import * as yup from "yup";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  Backdrop,
  Button,
  Checkbox,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  ThemeProvider,
} from "@mui/material";
import axios from "axios";
import { common_axios, common_axios_aayush } from "../../App";
import moment from "moment";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import Chip from "@mui/material/Chip";
import SaveIcon from "@mui/icons-material/Save";
import Loader from "../../components/Loader";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && {
    color: "#784af4",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <Person4Icon />,
    2: <CreditCardIcon />,
    3: <VideoLabelIcon />,
    4: <PersonPinIcon />,
    5: <ArticleIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const steps = [
  "Personal Details",
  "KYC Details",
  "Job Details",
  "Qualification and Languages Known",
  "Resume Uploader",
];

export default function ApplyTabForm() {
  // ----------------------------------------------------- functioning part

  const [data, setData] = useState({
    langauges: "",
    languageid: "",
    dateOfBirthh: "",
    locations: [],
    locationValues: "",
    Languageknwo1: "",
    Languageknwo2: "",
    Languageknwo3: "",
    stepper: 0,
    sources: [],
    sourceValues: "",
  });
  const [raddioValues, setraddioValues] = useState({
    title: "Mr.",
    gender: "M",
    maritalStatus: "S",
    jobExperience: "Yes",
  });

  // const [selectedImage, setSelectedImage] = useState("");

  // const [open, setOpen] = useState(false);

  const [openModal, setopenModal] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [resumePreview, setResumePreview] = useState("");
  const [open, setOpen] = useState(false);
  const [filePreview, setFilePreview] = useState("");
  const [fileName, setFileName] = useState("");
  const [filesize, setFileSize] = useState(0);
  const params = useParams();
  const location = useLocation();
  const history = useHistory();

  if (location?.pathname == `/register/${params?.id}/${params?.id1}`) {
    localStorage.setItem("username", params?.id);
    localStorage.setItem("state", params?.id1);
  }

  const validationSchema = yup.object({
    firstName: yup
      .string("Enter Your First name")
      .max(50, "First name must be at most 50 characters")
      .matches(
        /^[A-Za-z\s]*$/,
        "First name must not contain special characters"
      )
      .required("First name is required"),
    middleName: yup
      .string("Enter Your Middlename")
      .max(50, "Middle name must be at most 50 characters")
      .matches(
        /^[A-Za-z\s]*$/,
        "First name must not contain special characters"
      ),
    // .required("Middlename is required")
    surname: yup
      .string("Enter Your last name")
      .required("Last Name is required")
      .max(50, "Last name must be at most 50 characters")
      .matches(
        /^[A-Za-z\s]*$/,
        "First name must not contain special characters"
      ),

    fatherFullName: yup
      .string("Enter your father Name")
      .required("Father name is required")
      .max(50, "Father name must be at most 50 characters")
      .matches(
        /^[A-Za-z\s]*$/,
        "Father name must not contain special characters"
      ),
    husbandFullName: yup
      .string("Enter your husband Name")
      .max(50, "Husband name must be at most 50 characters")
      .matches(
        /^[A-Za-z\s]*$/,
        "Husband name must not contain special characters"
      ),
    residenceLocation: yup
      .string("Enter your residence location")
      .max(50, "Residence location must be at most 50 characters")
      .required("Residence location is required"),
    jobLocation: yup.string("Enter your job location"),
    nameOnAddharCard: yup
      .string("Enter Your Name as On Addhaar")
      .required("Name as On Addhaar is required")
      .min(3, "Name as On Addhaar should be at least 3 characters long"),
    HighestQualification: yup
      .string("Enter Your Highest Qualification")
      .required("Highest Qualification is required")
      .min(3, "Highest Qualification should be at least 3 characters long"),
    mobileNo: yup
      .string("Enter Your Mobile Number")
      .required("Mobile Number is required")
      .matches(/^\d{10}$/, "Mobile Number should be exactly 10 digits long")
      .required("Mobile Number is required"),
    email: yup.string().required("email is required!")?.email(),
    nameOnAddharCard: yup
      .string("Enter Your name as On aadhar")
      .required("Name as On aadhar is required")
      .max(50, "Name as on aadhar must be at most 50 characters")
      .matches(
        /^[A-Za-z\s]*$/,
        "Name as on aadhar must not contain special characters"
      ),
    HighestQualification: yup
      .string("Enter Your highest qualification")
      .max(50, "Highest qualification  must be at most 50 characters")
      .required("Highest qualification is required"),
    mobileNo: yup
      .string("Enter your mobile number")
      .required("Mobile number is required")
      .min(10, "Mobile number should not be less than 10 digit")
      .matches(/^\d{10}$/, "Mobile number should be exactly 10 digits long")
      .required("Mobile number is required"),
    altmobileNo: yup
      .string("Enter Your alternative mobile number")
      .required("Alternative mobile number is required")
      .min(10, "Mobile number should not be less than 10 digit")
      .matches(/^\d{10}$/, "Mobile number should be exactly 10 digits long"),
    // .required("Mobile number is required"),
    email: yup.string().required("email is required!")?.email(),
    AadharCardNo: yup
      .string("Enter your aadhar number")
      .required("aadhar number is required")
      .matches(/^\d{12}$/, "aadhar number should be exactly 12 digits long")
      .required("aadhar number is required"),
    panNumber: yup
      .string()
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Invalid PAN Number")
      .max(10, "PAN number should not exceed 10 characters"),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      firstName: "",
      middleName: "",
      surname: "",
      fatherFullName: "",
      mobileNo: "",
      altmobileNo: "",
      email: "",
      dateOfBirth: "",
      nationality: "Indian",
      gender: "",
      maritalStatus: "",
      husbandFullName: "",
      residenceLocation: "",
      JobExperience: "",
      jobLocation: "",
      source: 7,
      sourceName: "",
      AadharCardNo: "",
      panNumber: "",
      nameOnAddharCard: "",
      HighestQualification: "",
      LanguageKnown1: "",
      LanguageKnown2: "",
      LanguageKnown3: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        let obj = {
          personTitle: raddioValues?.title,
          surname: values?.surname,
          firstName: values?.firstName,
          middleName: values?.middleName,
          applicantEmail: values?.email,
          applicantPhone: String(values?.mobileNo),
          alternate_phone: String(values?.altmobileNo),
          dateOfBirth: moment(data?.dateOfBirthh).format("YYYY-MM-DD"),
          gender: raddioValues?.gender,
          nationality: "IN",
          maritalStatus: raddioValues?.maritalStatus,

          identityCard: String(values?.AadharCardNo),
          panNumber: String(values?.panNumber),

          created: new Date(),
          sourceId: data.sourceValues?.sourceId,
          sourceName:
            data.sourceValues?.sourceName !== "Walk In"
              ? values?.sourceName
              : "Walk In",
          locationId: data.locationValues?.locationId,
          applicantLocation: data.locationValues?.locationName,
          nameOnAadharCard: values?.nameOnAddharCard,
          highestQualification: values?.HighestQualification,

          jobExperience: raddioValues?.jobExperience,
          language1: personName?.[0]?.language,
          language2: personName?.[1]?.language,
          language3: personName?.[2]?.language,
          fatherFullName: values?.fatherFullName,
          husbandFullName: values?.husbandFullName,
          branchCode: "applicant",
          branchState: "bstate",
        };
        setOpen(true);

        const formdata = new FormData();

        formdata.append(
          "applicantRequest",
          new Blob([JSON.stringify(obj)], { type: "application/json" })
        );
        if (selectedImage) {
          formdata.append("resume", selectedImage);
        }

        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API_JOB_LOKESH_SIR}/onetouch-api/applicants/v1/create-applicant`,
          formdata,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": "f83OJ3D2xF1Bg8vub9tLe1gHMzV76e8Tus9uPHvRVEU",
            },
          }
        );

        if (res.data.statusCode == 200) {
          Swal.fire({
            title: res.data.message,
            // text: res.data.message,
            icon: "success",
          });

          setopenModal(res.data.response);
          formik.handleReset();
          document.getElementById("popModalInformation").click();

          setData((prev) => {
            return {
              ...prev,
              Languageknwo3: "",
              Languageknwo1: "",
              Languageknwo2: "",
              dateOfBirthh: "01-01-2000",
              locationValues: "",
              stepper: 0,
            };
          });
          // if (selectedImage) {
          //   document.getElementById("fileName").value = "";
          // }

          getAllsource();
          setraddioValues({
            title: "Mr.",
            gender: "M",
            maritalStatus: "S",
            jobExperience: "Yes",
          });
        } else {
          Swal.fire({
            title: "Oops!",
            text: res.data.message,
            icon: "error",
          });
          setData((prev) => {
            return {
              ...prev,
              stepper: 0,
            };
          });
        }
      } catch (error) {
        console.log(error, "err");

        Swal.fire({
          title: "Oops!",
          text: "Something went wrong ! Please try again",
          icon: "error",
        });
      } finally {
        setOpen(false);
      }
    },
  });

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const [personName, setPersonName] = React.useState([]);

  const handleChangeChip = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleChange = (newValue) => {
    setData((prevContent) => ({
      ...prevContent,

      dateOfBirthh: newValue?.$d,
    }));
  };

  const getAlllanguages = async () => {
    try {
      const res = await common_axios(`onetouch-api/masters/get/languages-list`);

      if (res.data.message == "Success") {
        setData((prevContent) => ({
          ...prevContent,

          langauges: res.data.response.response,
        }));

        // } else {
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getAllsource = async () => {
    try {
      const res = await common_axios(
        `/onetouch-api/masters/get/source-list`,
        {
          headers: {
            "X-API-KEY": "f83OJ3D2xF1Bg8vub9tLe1gHMzV76e8Tus9uPHvRVEU",
          },
        }
      );

      if (res.data.message == "Success") {
        setData((prevContent) => ({
          ...prevContent,

          sources: res.data.response.response,
        }));

        // } else {
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getAlllanguages();
    getAllsource();
  }, []);

  const getAlllocations = async () => {
    try {
      const res = await common_axios(
        `onetouch-api/masters/get/all/jobs/locations`
      );

      if (res.data.message == "Success") {
        setData((prevContent) => ({
          ...prevContent,

          locations: res.data.response.response,
        }));

        // } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAlllocations();
  }, []);

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#2191D0", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  useEffect(() => {
    if (raddioValues?.title == "Mr.") {
      setraddioValues((prev) => {
        return {
          ...prev,
          gender: "M",
        };
      });
    } else if (raddioValues?.title == "Mrs.") {
      setraddioValues((prev) => {
        return {
          ...prev,
          maritalStatus: "M",
          gender: "F",
        };
      });
    } else if (raddioValues?.title == "Ms.") {
      setraddioValues((prev) => {
        return {
          ...prev,
          maritalStatus: "S",
          gender: "F",
        };
      });
    } else {
      setraddioValues((prev) => {
        return {
          ...prev,
          gender: "F",
        };
      });
    }
  }, [raddioValues?.title]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setFilePreview(reader.result);
    };

    if (file) {
      if (file.type !== "application/pdf") {
        // Check if file type is not PDF
        // alert("Only PDF files are allowed.");
        Swal.fire({
          title: "Oops!",
          text: "Only PDF files are allowed.",
          icon: "error",
        });
        document.getElementById("fileName").value = ""; // Clear the file input
        setFilePreview(""); // Clear the file preview
        setFileName(""); // Clear the file name
        return; // Exit the function
      }

      if (file.size > 5 * 1024 * 1024) {
        // Check if file size is greater than 5MB
        // alert("File size exceeds the limit of 5MB.");
        Swal.fire({
          title: "Oops!",
          text: "File size exceeds the limit of 5MB",
          icon: "error",
        });
        document.getElementById("fileName").value = ""; // Clear the file input
        setFilePreview(""); // Clear the file preview
        setFileName(""); // Clear the file name
        return; // Exit the function
      }

      setFileName(file.name); // Set the file name
      setFileSize(file.size); // Set the file size
      reader.readAsDataURL(file);
    }
  };

  const bytes = filesize;
  const megabytes = bytes / (1024 * 1024);
  const clearFileInput = () => {
    setFilePreview("");
    setFileName("");
    document.getElementById("fileName").value = "";
  };
  return (
    <>
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
      >
        <Loader />
      </Backdrop>
      <button
        type="button"
        class="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        id="popModalInformation"
      >
        Launch demo modal
      </button>

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Form Details
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row">First Name</th>
                    <td>{openModal?.firstName}</td>
                  </tr>
                  <tr>
                    <th scope="row">Middle Name</th>
                    <td>{openModal?.middleName}</td>
                  </tr>
                  <tr>
                    <th scope="row">SurName</th>
                    <td>{openModal?.surname}</td>
                  </tr>
                  <tr>
                    <th scope="row">Email</th>
                    <td>{openModal?.applicantEmail}</td>
                  </tr>
                  <tr>
                    <th scope="row">Phone</th>
                    <td>{openModal?.applicantPhone}</td>
                  </tr>
                  <tr>
                    <th scope="row">Date Of Birth</th>
                    <td>
                      {moment(openModal?.dateOfBirthh).format("YYYY-MM-DD")}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Aadhar Card Number</th>
                    <td>{openModal?.identityCard}</td>
                  </tr>
                  <tr>
                    <th scope="row">Language Known 1</th>
                    <td>{openModal?.language1}</td>
                  </tr>
                  <tr>
                    <th scope="row">Language Known 2</th>
                    <td>{openModal?.language2}</td>
                  </tr>
                  <tr>
                    <th scope="row">Language Known 3</th>
                    <td>{openModal?.language3}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                onClick={() => {
                  window.location.href =
                    "http://114.143.73.92:9090/hr/index.jsp";
                }}
                class="btn btn-primary"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div class="card-body py-">
          <Stack
            sx={{ width: "100%", marginTop: "10px", marginBottom: "10px" }}
            spacing={4}
          >
            <Stepper
              alternativeLabel
              activeStep={data?.stepper}
              connector={<ColorlibConnector />}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={ColorlibStepIcon}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Stack>
        </div>
      </div>
      <section class="registration" id="registration">
        <div class="container-fluid py-5">
          <div class="card bg-white shadow-none border mt-  bg_blue">
            <span class="badge badge_heading rounded-pill bg-primary mt-n3 ms-5">
              Registration Form
            </span>
            {/* <form onSubmit={formik.handleSubmit}> */}
            <ThemeProvider theme={theme}>
              <div class="card-body m-0 py-">
                <div class="card shadow-none border mt-  bg_blue">
                  <div class="card-body m-0 py-">
                    {data?.stepper == 0 ? (
                      <>
                        <div class="row parent_row align-items-start mt-">
                          <div class="col-md-4 d-block">
                            <div class="row m-0">
                              <div className="col-2 p-0">
                                <button
                                  class="btn d-flex align-items-center w-100 btn-outline-secondary dropdown-toggle"
                                  style={{
                                    height: "40px",
                                    padding: "0.375rem 0.5rem",
                                  }}
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <span
                                    className="d-block text-white w-100"
                                    style={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {raddioValues?.title}
                                  </span>
                                </button>
                                <ul class="dropdown-menu">
                                  <li
                                    value={"Mr."}
                                    onClick={(e) => {
                                      setraddioValues((prevv) => {
                                        return {
                                          ...prevv,
                                          title: "Mr.",
                                        };
                                      });
                                    }}
                                  >
                                    <a class="dropdown-item">Mr.</a>
                                  </li>
                                  <li
                                    value={"Mrs."}
                                    onClick={(e) => {
                                      setraddioValues((prevv) => {
                                        return {
                                          ...prevv,
                                          title: "Mrs.",
                                        };
                                      });
                                    }}
                                  >
                                    <a class="dropdown-item" value={"Mrs."}>
                                      Mrs.
                                    </a>
                                  </li>
                                  <li
                                    value={"Ms."}
                                    onClick={(e) => {
                                      setraddioValues((prevv) => {
                                        return {
                                          ...prevv,
                                          title: "Ms.",
                                        };
                                      });
                                    }}
                                  >
                                    <a class="dropdown-item">Ms.</a>
                                  </li>
                                </ul>
                              </div>
                              <div className="col-10 p-0">
                                <TextField
                                  required
                                  style={{ width: "100%" }}
                                  name="firstName"
                                  label="First Name"
                                  variant="outlined"
                                  size="small"
                                  type="text"
                                  value={formik.values.firstName}
                                  onBlur={formik.handleBlur}
                                  onChange={formik.handleChange}
                                  error={
                                    formik.touched.firstName &&
                                    Boolean(formik.errors.firstName)
                                  }
                                  helperText={
                                    formik.touched.firstName &&
                                    formik.errors.firstName
                                  }
                                  inputProps={{
                                    maxLength: 51, // Limit the input to 50 characters
                                  }}
                                />
                              </div>
                              {/* {formik.touched.firstName &&
                                formik.errors.firstName ? (
                                  <div>{formik.errors.firstName}</div>
                                ) : null} */}
                            </div>
                          </div>
                          <div class="col-md-4">
                            <TextField
                              className="w-100"
                              name="middleName"
                              label="Middle Name"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.middleName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.middleName &&
                                Boolean(formik.errors.middleName)
                              }
                              helperText={
                                formik.touched.middleName &&
                                formik.errors.middleName
                              }
                              inputProps={{
                                maxLength: 51, // Limit the input to 50 characters
                              }}
                            />
                          </div>
                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              name="surname"
                              label="Last Name"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.surname}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.surname &&
                                Boolean(formik.errors.surname)
                              }
                              helperText={
                                formik.touched.surname && formik.errors.surname
                              }
                              inputProps={{
                                maxLength: 51, // Limit the input to 50 characters
                              }}
                            />
                          </div>

                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              name="fatherFullName"
                              label="Father Name"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.fatherFullName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.fatherFullName &&
                                Boolean(formik.errors.fatherFullName)
                              }
                              helperText={
                                formik.touched.fatherFullName &&
                                formik.errors.fatherFullName
                              }
                              inputProps={{
                                maxLength: 51, // Limit the input to 50 characters
                              }}
                            />
                          </div>
                          {raddioValues?.title == "Mrs." ? (
                            <div class="col-md-4">
                              <TextField
                                className="w-100"
                                name="husbandFullName"
                                label="Husband Full Name"
                                variant="outlined"
                                size="small"
                                type="text"
                                required={raddioValues?.maritalStatus == "M"}
                                value={formik.values.husbandFullName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.husbandFullName &&
                                  Boolean(formik.errors.husbandFullName)
                                }
                                helperText={
                                  formik.touched.husbandFullName &&
                                  formik.errors.husbandFullName
                                }
                                inputProps={{
                                  maxLength: 51, // Limit the input to 50 characters
                                }}
                              />
                            </div>
                          ) : null}

                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              name="mobileNo"
                              label="Mobile Number"
                              variant="outlined"
                              size="small"
                              type="number"
                              onInput={(e) => {
                                // Add hyphens after every 4 digits
                                if (e.target.value.length > 0) {
                                  e.target.value = Math.max(
                                    0,
                                    parseInt(e.target.value)
                                  )
                                    .toString()
                                    .slice(0, 10);
                                }
                              }}
                              value={formik.values.mobileNo}
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.mobileNo &&
                                Boolean(formik.errors.mobileNo)
                              }
                              helperText={
                                formik.touched.mobileNo &&
                                formik.errors.mobileNo
                              }
                            />
                          </div>
                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              name="altmobileNo"
                              label="Alternate Mobile Number"
                              variant="outlined"
                              size="small"
                              type="number"
                              onInput={(e) => {
                                // Add hyphens after every 4 digits
                                if (e.target.value.length > 0) {
                                  e.target.value = Math.max(
                                    0,
                                    parseInt(e.target.value)
                                  )
                                    .toString()
                                    .slice(0, 10);
                                }
                              }}
                              value={formik.values.altmobileNo}
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.altmobileNo &&
                                Boolean(formik.errors.altmobileNo)
                              }
                              helperText={
                                formik.touched.altmobileNo &&
                                formik.errors.altmobileNo
                              }
                            />
                          </div>
                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              name="email"
                              label="Email ID"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.email &&
                                Boolean(formik.errors.email)
                              }
                              helperText={
                                formik.touched.email && formik.errors.email
                              }
                            />
                          </div>
                          <div class="col-md-4 date_text d-block">
                            <LocalizationProvider
                              fullWidth
                              dateAdapter={AdapterDayjs}
                            >
                              <Stack spacing={3}>
                                <DesktopDatePicker
                                  className="w-100"
                                  style={{ color: "black" }}
                                  label="Date of Birth"
                                  inputFormat="DD/MM/YYYY"
                                  value={data?.dateOfBirthh}
                                  maxDate={dayjs().subtract(18, "year")}
                                  minDate={dayjs().subtract(60, "year")}
                                  onChange={handleChange}
                                  renderInput={(params) => (
                                    <TextField
                                      style={{
                                        textTransform: "none",
                                        color: "black",
                                      }}
                                      helperText="Age eligibility is between 18 to 60 years"
                                      required
                                      onKeyDown={(e) => {
                                        e.preventDefault();
                                      }}
                                      size="small"
                                      {...params}
                                    />
                                  )}
                                />
                              </Stack>
                            </LocalizationProvider>
                          </div>
                          <div class="col-md-4">
                            {/* <div class="d-flex align-items-center flex-wrap"> */}
                            <label class="form-label m-0">Gender</label>
                            <div class="form-check">
                              <FormControl>
                                <RadioGroup
                                  className="nikhil_radio"
                                  row
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  name="row-radio-buttons-group"
                                  value={raddioValues?.gender}
                                  onChange={(e) => {
                                    setraddioValues((prev) => {
                                      return {
                                        ...prev,
                                        gender: e.target.value,
                                      };
                                    });
                                  }}
                                >
                                  <FormControlLabel
                                    value="M"
                                    disabled={
                                      raddioValues?.title == "Mrs." ||
                                      raddioValues?.title == "Ms."
                                    }
                                    control={<Radio />}
                                    label="Male"
                                  />
                                  <FormControlLabel
                                    value="F"
                                    disabled={raddioValues?.title == "Mr."}
                                    control={<Radio />}
                                    label="Female"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                            {/* </div> */}
                          </div>

                          <div class="col-md-4">
                            <label class="form-label m-0">Marital Status</label>
                            <div class="d-flex align-items-center flex-wrap">
                              <FormControl>
                                <RadioGroup
                                  row
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  name="row-radio-buttons-group"
                                  value={raddioValues?.maritalStatus}
                                  onChange={(e) => {
                                    setraddioValues((prev) => {
                                      return {
                                        ...prev,
                                        maritalStatus: e.target.value,
                                      };
                                    });
                                  }}
                                >
                                  <FormControlLabel
                                    value="S"
                                    control={<Radio />}
                                    label="Single"
                                    disabled={raddioValues?.title == "Mrs."}
                                  />
                                  <FormControlLabel
                                    value="M"
                                    control={<Radio />}
                                    label="Married"
                                    disabled={raddioValues?.title == "Ms."}
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : data?.stepper == 1 ? (
                      <>
                        <div class="row parent_row align-items-start mt-">
                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              disabled
                              label="Nationality"
                              name="nationality"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.nationality}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.nationality &&
                                Boolean(formik.errors.nationality)
                              }
                              helperText={
                                formik.touched.nationality &&
                                formik.errors.nationality
                              }
                            />
                          </div>
                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              name="AadharCardNo"
                              label="aadhar Card No"
                              variant="outlined"
                              size="small"
                              type="number"
                              onInput={(e) => {
                                // Add hyphens after every 4 digits
                                if (e.target.value.length > 0) {
                                  e.target.value = Math.max(
                                    0,
                                    parseInt(e.target.value)
                                  )
                                    .toString()
                                    .slice(0, 12);
                                }
                              }}
                              value={formik.values.AadharCardNo}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.AadharCardNo &&
                                Boolean(formik.errors.AadharCardNo)
                              }
                              helperText={
                                formik.touched.AadharCardNo &&
                                formik.errors.AadharCardNo
                              }
                            />
                          </div>
                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              label="Name on aadhar"
                              name="nameOnAddharCard"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.nameOnAddharCard}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.nameOnAddharCard &&
                                Boolean(formik.errors.nameOnAddharCard)
                              }
                              helperText={
                                formik.touched.nameOnAddharCard &&
                                formik.errors.nameOnAddharCard
                              }
                              inputProps={{
                                maxLength: 51, // Limit the input to 50 characters
                              }}
                            />
                          </div>

                          <div class="col-md-4">
                            {/* <TextField
                                error={
                                  formik.touched.panNumber &&
                                  !/^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/.test(
                                    formik.values?.panNumber.toUpperCase()
                                  )
                                }
                                className="w-100"
                                name="pan Number"
                                label="PAN Number"
                                helperText="Format: ABCDE4321S"
                                variant="outlined"
                                size="small"
                                value={formik.values.panNumber.toUpperCase()}
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  const inputValue =
                                    e.target.value.toUpperCase();
                                  if (
                                    /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/.test(
                                      inputValue
                                    )
                                  ) {
                                    formik.handleChange({
                                      target: {
                                        name: "panNumber",
                                        value: inputValue,
                                      },
                                    });
                                  }
                                }}
                              /> */}

                            <TextField
                              error={
                                formik.touched.panNumber &&
                                !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(
                                  formik.values.panNumber.toUpperCase()
                                )
                              }
                              className="w-100"
                              name="panNumber"
                              label="PAN Number"
                              helperText={
                                formik.touched.panNumber &&
                                  !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(
                                    formik.values.panNumber.toUpperCase()
                                  )
                                  ? "Enter valid PAN number,Format: ABCDE4321S"
                                  : ""
                              }
                              variant="outlined"
                              size="small"
                              value={formik.values.panNumber.toUpperCase()}
                              onBlur={formik.handleBlur}
                              onChange={(e) => {
                                const inputValue = e.target.value.toUpperCase();
                                if (
                                  /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/.test(
                                    inputValue
                                  )
                                ) {
                                  formik.setFieldValue("panNumber", inputValue);
                                }
                              }}
                            />

                            {/* <TextField
                                error={
                                  formik.touched.panNumber &&
                                  !/^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/.test(
                                    formik.values.panNumber.toUpperCase()
                                  )
                                }
                                className="w-100"
                                name="panNumber"
                                label="PAN Number"
                                helperText={
                                  formik.touched.panNumber &&
                                  !/^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/.test(
                                    formik.values.panNumber.toUpperCase()
                                  )
                                    ? "Invalid PAN Number. Format: ABCDE4321S"
                                    : ""
                                }
                                variant="outlined"
                                size="small"
                                value={formik.values.panNumber.toUpperCase()}
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  const inputValue =
                                    e.target.value.toUpperCase();
                                  if (/^[A-Z0-9]*$/.test(inputValue)) {
                                    // Updated regex to allow only alphanumeric characters
                                    formik.setFieldValue(
                                      "panNumber",
                                      inputValue
                                    );
                                  }
                                }}
                              /> */}
                          </div>

                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              name="residenceLocation"
                              label="Residence Location"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.residenceLocation}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.residenceLocation &&
                                Boolean(formik.errors.residenceLocation)
                              }
                              helperText={
                                formik.touched.residenceLocation &&
                                formik.errors.residenceLocation
                              }
                              inputProps={{
                                maxLength: 51, // Limit the input to 50 characters
                              }}
                            />
                          </div>
                        </div>
                      </>
                    ) : data?.stepper == 2 ? (
                      <>
                        <div class="row parent_row align-items-start mt-">
                          <div class="col-md-6">
                            {/* <div class="d-flex align-items-center flex-wrap"> */}
                            <label
                              class="form-label m-0"
                              style={{
                                textTransform: "none",
                              }}
                            >
                              Do you have previous job experience
                            </label>
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                className="ms-5"
                                name="row-radio-buttons-group"
                                value={raddioValues?.jobExperience}
                                onChange={(e) => {
                                  setraddioValues((prev) => {
                                    return {
                                      ...prev,
                                      jobExperience: e.target.value,
                                    };
                                  });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </FormControl>
                            {/* </div> */}
                          </div>
                          <div class="col-md-3">
                            <FormControl required fullWidth>
                              <InputLabel
                                size="small"
                                id="demo-simple-select-label"
                              >
                                Preferred Job Location
                              </InputLabel>
                              <Select
                                style={{ background: "white" }}
                                className="w-100"
                                size="small"
                                required
                                label="Preferred Job Location"
                                placeholder="Preferred Job Location"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.locationValues}
                                onChange={(e) => {
                                  setData((prevContent) => ({
                                    ...prevContent,

                                    locationValues: e.target?.value,
                                  }));
                                }}
                              >
                                {data?.locations?.map((e) => {
                                  return (
                                    <MenuItem value={e}>
                                      {e?.locationName}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </div>
                          <div class="col-md-3">
                            <FormControl required fullWidth>
                              <InputLabel
                                size="small"
                                id="demo-simple-select-label"
                              >
                                Select Source
                              </InputLabel>
                              <Select
                                style={{ background: "white" }}
                                className="w-100"
                                size="small"
                                required
                                label="Select Source"
                                placeholder="Select Source"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data?.sourceValues}
                                onChange={(e) => {
                                  setData((prevContent) => ({
                                    ...prevContent,

                                    sourceValues: e.target?.value,
                                  }));
                                }}
                              >
                                {data?.sources
                                  ?.map((e) => {
                                    return (
                                      <MenuItem value={e}>
                                        {e?.sourceName}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                          {data?.sourceValues?.sourceId !==4 && 
                           <div class="col-md-3">
                            <TextField
                              required
                              className="w-100"
                              name="sourceName"
                              label="Source Name"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.sourceName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.sourceName &&
                                Boolean(formik.errors.sourceName)
                              }
                              helperText={
                                formik.touched.sourceName &&
                                formik.errors.sourceName
                              }
                              inputProps={{
                                maxLength: 51, // Limit the input to 50 characters
                              }}
                            />
                          </div>
                          }
                         
                        </div>
                      </>
                    ) : data?.stepper == 3 ? (
                      <>
                        <div class="row parent_row align-items-start mt-">
                          <div class="col-md-4">
                            <TextField
                              required
                              className="w-100"
                              name="HighestQualification"
                              label="Highest Qualification"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={formik.values.HighestQualification}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.HighestQualification &&
                                Boolean(formik.errors.HighestQualification)
                              }
                              helperText={
                                formik.touched.HighestQualification &&
                                formik.errors.HighestQualification
                              }
                              inputProps={{
                                maxLength: 51, // Limit the input to 50 characters
                              }}
                            />
                          </div>
                          <div class="col-md-4 date_text">
                            <FormControl
                              className="m-0 w-100"
                              sx={{
                                // width: 350,
                                marginTop:
                                  personName?.length > 3 ||
                                    personName?.length < 3
                                    ? "20px"
                                    : "5px",
                              }}
                              required
                              error={personName?.length > 3 ? true : false}
                            >
                              <InputLabel
                                required
                                size="small"
                                id="demo-multiple-checkbox-label"
                              >
                                Languages Known
                              </InputLabel>
                              <Select
                                size="small"
                                fullWidth
                                required
                                className="w-100"
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={personName}
                                onChange={handleChangeChip}
                                input={
                                  <OutlinedInput label="Languages Known" />
                                }
                                renderValue={(selected) => {
                                  const selectedNames = selected.map(
                                    (value) => value.language
                                  );
                                  return selectedNames.join(", ");
                                }}
                                MenuProps={MenuProps}
                              >
                                {data?.langauges?.length > 0 &&
                                  data?.langauges?.map((name) => (
                                    <MenuItem key={name} value={name}>
                                      <Checkbox
                                        checked={personName.indexOf(name) > -1}
                                      />
                                      <ListItemText primary={name?.language} />
                                    </MenuItem>
                                  ))}
                              </Select>
                              {(personName?.length > 3 ||
                                personName?.length < 3) && (
                                  <FormHelperText>
                                    Please Select any 3
                                  </FormHelperText>
                                )}
                            </FormControl>
                          </div>
                        </div>
                      </>
                    ) : data?.stepper == 4 ? (
                      <>
                        <div class="row parent_row align-items-start mt-">
                          <div class="col-md-4 d-block">
                            <h5
                              style={{
                                // color: "red",
                                marginLeft: "10px",
                                fontSize: "13px",
                              }}
                            >
                              Upload resume
                            </h5>
                            <div class="input-group">
                              <input
                                type="file"
                                id="fileName"
                                // required
                                className="form-control"
                                aria-describedby="inputGroupFileAddon04"
                                aria-label="Upload"
                                accept=".pdf"
                                onChange={(e) => {
                                  handleImageChange(e);
                                }}
                              />
                              <CancelIcon
                                style={{
                                  marginLeft: "10px",
                                  marginTop: "5px",
                                }}
                                onClick={clearFileInput}
                              />
                            </div>
                            <label htmlFor="resume-upload">
                              {/* <span
                                  style={{
                                    color: "red",
                                    marginLeft: "10px",
                                    fontSize: "13px",
                                  }}
                                >
                                  Upload resume
                                </span> */}
                              <span
                                className="resume_color"
                                style={{
                                  color: "red",
                                  textTransform: "none",
                                  marginLeft: "10px",
                                  fontSize: "13px",
                                  fontFamily: "italic",
                                }}
                              >
                                Only PDF file format is allowed(Maximum size - 5
                                MB)
                              </span>
                            </label>
                          </div>
                          {/* <div className="col-md-3">
                              {resumePreview && (
                                <div>
                                  <h2>Preview:</h2>
                                  <embed
                                    src={resumePreview}
                                    type="application/pdf"
                                    width="100%"
                                    height="600px"
                                  />
                                </div>
                              )}
                            </div> */}
                          <div className="col-md-2">
                            {/* {fileName} */}
                            {filePreview && (
                              <div>
                                <span
                                  className="d-block text-center resume_txt_color"
                                  style={{
                                    textTransform: "none",
                                  }}
                                >
                                  One file attached
                                </span>

                                <iframe
                                  className="w-100 h-auto resume_upload"
                                  title="PDF Preview"
                                  src={filePreview}
                                  width="200"
                                  height="242"
                                  style={{ border: "1px solid black" }}
                                />
                                <span
                                  className="text-center d-block"
                                  style={{ display: "block" }}
                                >
                                  {"File Size:" + megabytes.toFixed(3) + "MB"}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="row">
                            <span
                              style={{
                                color: "red",
                                marginLeft: "10px",
                                fontSize: "13px",
                              }}
                            >
                              Only .pdf files are allowed *
                            </span>
                          </div> */}
                        {/* <div className="row">
                            <span
                              style={{
                                color: "red",
                                marginLeft: "10px",
                                fontSize: "13px",
                              }}
                            >
                              Upload resume
                            </span>
                            <span
                              style={{
                                color: "red",
                                marginLeft: "10px",
                                fontSize: "13px",
                              }}
                            >
                              Only .pdf files (max. 5 MB) are allowed *
                            </span>
                          </div> */}
                        {/* 
                          <label htmlFor="resume-upload">
                            <span
                              style={{
                                color: "red",
                                marginLeft: "10px",
                                fontSize: "13px",
                              }}
                            >
                              Upload resume
                            </span>
                          </label> */}
                        <input
                          type="file"
                          id="resume-upload"
                          accept=".pdf"
                          style={{ display: "none" }}
                          onChange={handleImageChange}
                        />
                        {/* <span
                            style={{
                              color: "red",
                              marginLeft: "10px",
                              fontSize: "13px",
                            }}
                          >
                            Only .pdf files (max. 5 MB) are allowed *
                          </span> */}
                      </>
                    ) : null}
                  </div>
                </div>
                <div className="text-end mt-3">
                  {data?.stepper != 0 && (
                    <Button
                      className="m-0"
                      variant="contained"
                      startIcon={<ArrowBackIosIcon />}
                      sx={{
                        backgroundColor: "red",
                        marginRight: "10px",
                        marginBottom: "10px",
                      }}
                      disabled={data?.stepper == 0}
                      onClick={() => {
                        setFilePreview("");
                        setData((prevv) => {
                          return {
                            ...prevv,
                            stepper: prevv.stepper - 1,
                          };
                        });
                      }}
                    >
                      Back
                    </Button>
                  )}
                 
                  {data?.stepper == 4 ? (
                    <Button
                      className="m-0 ms-2"
                      // type="submit"
                      variant="contained"
                      endIcon={<SaveIcon />}
                      sx={{
                        backgroundColor: "green",
                        marginRight: "10px",
                        marginBottom: "10px",
                      }}
                      onClick={() => {
                        formik.handleSubmit();
                      }}
                    >
                      Submit
                    </Button>
                  ) : (
                    <>
                      <Button
                        className="m-0 ms-2"
                        variant="contained"
                        endIcon={<NavigateNextIcon />}
                        sx={{
                          backgroundColor: "green",
                          marginRight: "10px",
                          marginBottom: "10px",
                        }}
                        disabled={(function () {
                          if (data?.stepper == 0) {
                            if (
                              formik.values.firstName?.length < 1 ||
                              !data.dateOfBirthh ||
                              // formik.values.middleName?.length < 3 ||
                              formik.values.surname?.length < 1 ||
                              formik.values.fatherFullName?.length < 1 ||
                              (raddioValues?.title == "Mrs." &&
                                formik.values.husbandFullName?.length < 1) ||
                              formik.values.email?.length < 1 ||
                              String(formik.values.mobileNo)?.length < 10 ||
                              String(formik.values.altmobileNo)?.length < 10 ||
                              formik.errors.firstName ||
                              formik.errors.surname ||
                              formik.errors.fatherFullName
                            ) {
                              return true;
                            }
                            return false;
                          } else if (data?.stepper == 1) {
                            if (
                              formik.values.nameOnAddharCard?.length < 1 ||
                              formik.errors.nameOnAddharCard ||
                              String(formik.values.AadharCardNo)?.length < 12 ||
                              formik.values.residenceLocation?.length < 1 ||
                              (formik?.values?.panNumber?.length > 0 &&
                                formik?.values?.panNumber.length != 10)
                            ) {
                              return true;
                            }
                            return false;
                          } else if (data?.stepper == 2) {
                            if (
                              formik.values.nameOnAddharCard?.length < 1 ||
                              data.locationValues == "" || data?.sourceValues?.sourceId == null ||  (data?.sourceValues?.sourceId !== 4 && !formik.values.sourceName)
                            ) {
                              return true;
                            }
                            return false;
                          } else if (data?.stepper == 3) {
                            if (
                              personName.length < 3 ||
                              personName.length > 3 ||
                              formik.values?.HighestQualification?.length < 1
                            ) {
                              return true;
                            }
                            return false;
                          }
                        })()}
                        onClick={() => {
                          setData((prevv) => {
                            return {
                              ...prevv,
                              stepper: prevv.stepper + 1,
                            };
                          });
                        }}
                      >
                        Next
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </ThemeProvider>
            {/* <div className="text-end">
                {data?.stepper != 0 && (
                  <Button
                    variant="contained"
                    startIcon={<ArrowBackIosIcon />}
                    sx={{
                      backgroundColor: "red",
                      marginRight: "10px",
                      marginBottom: "10px",
                    }}
                    disabled={data?.stepper == 0}
                    onClick={() => {
                      setData((prevv) => {
                        return {
                          ...prevv,
                          stepper: prevv.stepper - 1,
                        };
                      });
                    }}
                  >
                    Back
                  </Button>
                )}
                {data?.stepper == 4 ? (
                  <Button
                    type="submit"
                    variant="contained"
                    endIcon={<SaveIcon />}
                    sx={{
                      backgroundColor: "green",
                      marginRight: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    Submit
                  </Button>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      endIcon={<NavigateNextIcon />}
                      sx={{
                        backgroundColor: "green",
                        marginRight: "10px",
                        marginBottom: "10px",
                      }}
                      disabled={(function () {
                        if (data?.stepper == 0) {
                          if (
                            formik.values.firstName?.length < 3 ||
                            formik.values.middleName?.length < 3 ||
                            formik.values.surname?.length < 3 ||
                            formik.values.fatherFullName?.length < 3 ||
                            (raddioValues?.title == "Mrs." &&
                              formik.values.husbandFullName?.length < 3) ||
                            formik.values.email?.length < 3 ||
                            String(formik.values.mobileNo)?.length < 10
                          ) {
                            return true;
                          }
                          return false;
                        } else if (data?.stepper == 1) {
                          if (
                            formik.values.nameOnAddharCard?.length < 3 ||
                            String(formik.values.AadharCardNo)?.length < 12 ||
                            formik.values.residenceLocation?.length < 3
                          ) {
                            return true;
                          }
                          return false;
                        } else if (data?.stepper == 2) {
                          if (
                            formik.values.nameOnAddharCard?.length < 3 ||
                            data.locationValues == ""
                          ) {
                            return true;
                          }
                          return false;
                        } else if (data?.stepper == 3) {
                          if (
                            personName.length < 3 ||
                            personName.length > 3 ||
                            formik.values?.HighestQualification?.length < 3
                          ) {
                            return true;
                          }
                          return false;
                        }
                      })()}
                      onClick={() => {
                        setData((prevv) => {
                          return {
                            ...prevv,
                            stepper: prevv.stepper + 1,
                          };
                        });
                      }}
                    >
                      Next
                    </Button>
                  </>
                )}
              </div> */}
            {/* </form> */}
          </div>
        </div>
      </section>
    </>
  );
}
